import { all_routes } from "../../../router/all_routes";
import { RolesEnum } from "../../../types/route.types";
import { SidebarItem } from "../../../types/sidebar.types";
import { PermissionType } from "../../../types/user.types";
const routes = all_routes;

// ⚠️ CRITICAL: Sub durumuna göre menü filtreleme fonksiyonu
export const filterMenuBySubStatus = (menuItems: SidebarItem[], sub: any, user: any): SidebarItem[] => {
  if (!sub) return menuItems;

  // 🔥 SuperAdmin'ler abonelik kontrolünden muaf - her zaman normal menüyü göster
  const isSuperAdmin = user?.role === RolesEnum.SUPERADMIN;
  if (isSuperAdmin) {
    return menuItems;
  }

  // 🚨 EXPIRED = TRUE: Sadece pricing sayfasına erişim ver (SuperAdmin hariç)
  if (sub.status === 'expired' || sub.status === 'inactive') {
    return [{
      tittle: sub.status === 'trial' ? 'Deneme Süresi Bitti' : 'Abonelik Süresi Bitti',
      icon: 'alert-triangle',
      showAsTab: false,
      separateRoute: true,
      role: [PermissionType.PRICING_ACCESS],
      submenuItems: [{
        label: sub.status === 'trial' ? 'Premium Planı Satın Al' : 'Aboneliği Yenile',
        link: routes.pricing,
        base: 'pricing',
        icon: 'credit-card',
        role: [PermissionType.PRICING_ACCESS],
      }]
    }];
  }

  // 🟢 EXPIRED = FALSE: Normal menü (trial ya da premium fark etmez)
  // Trial kullanıcılar Company Settings'de premium plan tanıtımını görür
  // Premium kullanıcılar Company Settings'de plan yönetimi yapar
  // Sidebar'da ek menü eklemeye gerek yok
  return menuItems;
};
export const SidebarDataTest: SidebarItem[] = [
  {
    tittle: 'sidebar_menu.main_menu.userTitle',
    icon: 'airplay',
    showAsTab: true,
    separateRoute: false,
    role: [PermissionType.CONTROL_PANEL_USER],
    submenuItems: [

      // {
      //   label: 'sidebar_menu.main_menu.dashboard',
      //   link: routes.employeeDashboard,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: 'smart-home',
      //   base: 'dashboard',
      //   role: [PermissionType.CONTROL_PANEL_USER],
      //   materialicons: 'start',
      // },


      {
        label: 'sidebar_menu.hrm.tickets',
        link: routes.ticketEmployee,
        base: 'ticket-list',
        role: [PermissionType.VIEW_TICKETS_USER],
        icon: 'ticket',
      },

      {
        label: 'sidebar_menu.hrm.leaves',
        link: routes.leaveemployee,
        submenu: false,
        showSubRoute: false,
        role: [PermissionType.LEAVE_REQUEST],
        icon: 'check',
      },



    ],
  },

  {
    tittle: 'sidebar_menu.main_menu.adminTitle',
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.CONTROL_PANEL_ADMIN],
    submenuItems: [
      {
        label: 'sidebar_menu.main_menu.dashboard',
        link: routes.adminDashboard,
        submenu: false,
        showSubRoute: false,
        icon: 'smart-home',
        base: 'dashboard',
        role: [PermissionType.CONTROL_PANEL_ADMIN],
        materialicons: 'start',
        dataTour: 'dashboard-stats',
      },
      {
        // Bekleyen onay sayısı sidebar'da rozet olarak gösterilir (bkz. shared/sidebar)
        label: 'sidebar_menu.hrm.approvals',
        link: routes.approvals,
        submenu: false,
        showSubRoute: false,
        icon: 'checklist',
        base: 'approvals',
        role: [PermissionType.CONTROL_PANEL_ADMIN],
      },
      {
        label: 'sidebar_menu.hrm.employee_list',
        link: routes.employeeList,
        submenu: false,
        showSubRoute: false,
        base: 'dashboard',
        role: [PermissionType.VIEW_USERS],
        icon: 'users',
        dataTour: 'employees-table',
      },
      {
        label: 'Cihaz ID Sıfırlama',
        link: routes.deviceConflicts,
        submenu: false,
        showSubRoute: false,
        base: 'device-conflicts',
        role: [PermissionType.EDIT_USERS],
        icon: 'device-mobile-exclamation',
      },
      {
        label: 'sidebar_menu.hrm.departments',
        link: routes.departments,
        base: 'departments',
        role: [PermissionType.VIEW_DEPARTMENTS],
        icon: 'category',
        dataTour: 'departments-list',
      },
      {
        link: routes.branches,
        label: 'sidebar_menu.administration.branch',
        base: 'stores',
        submenu: false,
        showSubRoute: false,
        icon: 'building',
        role: [PermissionType.VIEW_BRANCHES],
        dataTour: 'branches-list',
      },
      {
        link: routes.attendance,
        label: 'sidebar_menu.administration.attendance',
        base: 'attendance-report',
        icon: 'receipt',
        role: [PermissionType.VIEW_REPORTS],
        dataTour: 'attendance-report',
      },
      {
        label: 'sidebar_menu.administration.shift',
        link: routes.shift,
        base: 'shift',
        role: [PermissionType.MANAGE_SHIFTS],
        icon: 'calendar',
        dataTour: 'shifts-list',
      },
      {
        label: 'sidebar_menu.hrm.leaves',
        link: routes.leaveadmin,
        role: [PermissionType.VIEW_LEAVE],
        icon: 'check',
        dataTour: 'leaves-list',
      },
      {
        label: 'sidebar_menu.hrm.overtime',
        link: routes.overtimePending, // Tek sayfa - içinde tab'larla bekleyen/geçmiş
        icon: 'clock',
        base: 'overtime',
        submenu: false,
        showSubRoute: false,
        role: [PermissionType.OVERTIME],
      },
      {
        label: 'sidebar_menu.hrm.tickets',
        link: routes.ticketAdmin,
        base: 'ticket-list',
        role: [PermissionType.VIEW_TICKETS_ADMIN],
        icon: 'ticket',
        dataTour: 'tickets-list',
      },
      {
        label: 'sidebar_menu.hrm.forgotten_checkouts',
        link: routes.forgotCheckOut,
        base: 'forgotten-checkouts',
        role: [PermissionType.VIEW_REPORTS],
        icon: 'user',
        dataTour: 'forgot-checkout',
      },
      {
        label: 'sidebar_menu.hrm.forgotten_checkin',
        link: routes.forgotCheckIn,
        base: 'forgotten-checkin',
        role: [PermissionType.VIEW_REPORTS],
        icon: 'user',
        dataTour: 'forgot-checkin',
      },
      {
        link: routes.assets,
        label: 'sidebar_menu.administration.assets',
        base: 'inventory',
        icon: 'archive',
        role: [PermissionType.VIEW_ASSETS],
        dataTour: 'assets-list',
      },
      {
        link: routes.meals,
        label: 'sidebar_menu.administration.meals',
        base: 'meals',
        icon: 'receipt',
        role: [PermissionType.VIEW_MEALS],
        dataTour: 'meals-list',
      },
    ],
  },

  {
    tittle: 'sidebar_menu.main_menu.reportsTitle',
    icon: 'file',
    showAsTab: true,
    separateRoute: false,
    role: [PermissionType.VIEW_REPORTS],
    submenuItems: [
      {
        link: routes.employeeReport,
        label: 'sidebar_menu.administration.employee_report',
        base: 'employee-report',
        icon: 'users',
        role: [PermissionType.VIEW_REPORTS],
        dataTour: 'employee-report',
      },
      {
        link: routes.shiftReport,
        label: 'sidebar_menu.administration.shift_report',
        base: 'shift-report',
        icon: 'calendar',
        role: [PermissionType.VIEW_REPORTS],
        dataTour: 'shift-report',
      },
      // {
      //   link:routes.ticketReport,
      //   label: 'sidebar_menu.administration.ticket_report',
      //   base: 'ticket-report',
      //   icon: 'ticket',
      //   role:[PermissionType.VIEW_TICKETS_ADMIN],
      // },

      // {
      //   link:routes.attendanceReport,
      //   label: 'sidebar_menu.administration.attendance_report',
      //   base: 'attendance-report',
      //   icon: 'receipt',
      //   role:RolesEnum.ADMIN,
      // },

      {
        link: routes.leaveReport,
        label: 'sidebar_menu.administration.leave_report',
        base: 'leave-report',
        icon: 'check',
        role: [PermissionType.VIEW_LEAVE],
        dataTour: 'leave-report',
      },
      {
        label: 'sidebar_menu.administration.break_report',
        link: routes.breakReport,
        base: 'employeesReports',
        role: [PermissionType.VIEW_REPORTS],
        icon: 'receipt',
        dataTour: 'break-report',
      },
      {
        label: 'sidebar_menu.administration.documents',
        link: routes.documents,
        base: 'documents',
        role: [PermissionType.FILE_VIEW],
        icon: 'file-text',
        dataTour: 'documents',
      },
      {
        label: 'sidebar_menu.administration.company_report',
        link: routes.companyReport,
        base: 'company-report',
        role: [PermissionType.VIEW_COMPANY_PAYMENT],
        icon: 'building',
      },
      // {
      //   label: 'sidebar_menu.administration.payroll_report',
      //   link: routes.payrollReport,
      //   base: 'payroll-report',
      //   role: [PermissionType.VIEW_REPORTS],
      //   icon: 'receipt',
      // },
      {
        label: 'sidebar_menu.administration.timesheet_report',
        link: routes.timesheetReport,
        base: 'timesheet-report',
        role: [PermissionType.VIEW_COMPANY_TIMESHEET],
        icon: 'clock',
        dataTour: 'timesheet-report',
      }
    ],
  },
  {
    tittle: 'Saha Yönetimi',
    icon: 'map-pin',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.VIEW_FIELD_ACTIVITIES],
    submenuItems: [
      {
        link: routes.personelActivities,
        label: 'Personel Aktiviteleri',
        base: 'personel-activities',
        icon: 'briefcase',
        role: [PermissionType.VIEW_FIELD_ACTIVITIES],
      },
      {
        link: routes.vehicles,
        label: 'Araç Yönetimi',
        base: 'vehicles',
        icon: 'car',
        role: [PermissionType.VIEW_VEHICLES],
      },
      {
        link: routes.fieldModeRequests,
        label: 'Saha Modu Talepleri',
        base: 'field-mode-requests',
        icon: 'map-pin',
        role: [PermissionType.FIELD_MODE_REQUESTS],
      },
      {
        link: routes.activityRequests,
        label: 'Aktivite Talepleri',
        base: 'activity-requests',
        icon: 'clipboard-check',
        role: [PermissionType.VIEW_FIELD_ACTIVITIES],
      }
    ],
  },
  {
    tittle: 'sidebar_menu.main_menu.settingsTitle',
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.COMPANY],
    submenuItems: [
      {
        link: routes.companySettings,
        label: 'sidebar_menu.administration.company_settings',
        base: 'company-settings',
        icon: 'settings',
        role: [PermissionType.COMPANY],
        dataTour: 'company-settings',
      },
      {
        link: routes.notification,
        label: 'sidebar_menu.administration.notification',
        base: 'notification',
        icon: 'bell',
        role: [PermissionType.CREATE_NOTIFICATIONS],
        dataTour: 'notification-settings',
      },

    ]
  },

  // === REFERANS PROGRAMI ===
  {
    tittle: 'Referans Programı',
    icon: 'gift',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.MANAGE_REFERRAL_CAMPAIGNS],
    submenuItems: [
      {
        link: routes.referralProgram,
        label: 'Referans Programı',
        base: 'referral-program',
        icon: 'gift',
        role: [PermissionType.MANAGE_REFERRAL_CAMPAIGNS],
        dataTour: 'referral-program',
      },
    ]
  },

  // === SÜPER ADMİN DASHBOARD ===
  {
    tittle: 'sidebar_menu.main_menu.superAdminTitle',
    icon: 'dashboard',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_DASHBOARD],
    submenuItems: [
      {
        link: routes.superAdminDashboard2,
        label: 'sidebar_menu.administration.dashboard',
        base: 'dashboard',
        icon: 'smart-home',
        role: [PermissionType.SUPER_ADMIN_DASHBOARD],
      },
      {
        link: routes.superAdminAboutUs,
        label: 'Hakkımızda',
        base: 'about-us',
        icon: 'info',
        role: [PermissionType.SUPER_ADMIN_SYSTEM_SETTINGS],
      },

    ]
  },

  // === ŞİRKET YÖNETİMİ ===
  {
    tittle: 'sidebar_menu.main_menu.companyTitle',
    icon: 'building',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_VIEW_COMPANIES],
    submenuItems: [
      {
        link: routes.superAdminCompanies,
        label: 'sidebar_menu.administration.companies',
        base: 'companies',
        icon: 'building',
        role: [PermissionType.SUPER_ADMIN_VIEW_COMPANIES],
      },
      {
        link: routes.superAdminCompanyCreate,
        label: 'sidebar_menu.administration.company_create',
        base: 'company-create',
        icon: 'plus',
        role: [PermissionType.SUPER_ADMIN_CREATE_COMPANY],
      }
    ]
  },

  // === REFERANS KAMPANYALARI ===
  {
    tittle: 'Referans Kampanyaları',
    icon: 'gift',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS],
    submenuItems: [
      {
        link: routes.superAdminReferralCampaigns,
        label: 'Kampanya Yönetimi',
        base: 'referral-campaigns',
        icon: 'gift',
        role: [PermissionType.SUPER_ADMIN_MANAGE_REFERRAL_CAMPAIGNS],
      }
    ]
  },

  // === KUPON YÖNETİMİ ===
  {
    tittle: 'sidebar_menu.main_menu.couponsTitle',
    icon: 'ticket',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_MANAGE_COUPONS],
    submenuItems: [
      {
        link: routes.coupons,
        label: 'Kupon Yönetimi',
        base: 'coupons',
        icon: 'ticket',
        role: [PermissionType.SUPER_ADMIN_MANAGE_COUPONS],
      },
    ]
  },
  // === FİNANSAL YÖNETİM ===
  {
    tittle: 'sidebar_menu.main_menu.paymentTitle',
    icon: 'credit-card',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_VIEW_FINANCIALS],
    submenuItems: [
      {
        link: routes.paymentReports,
        label: 'Ödeme Raporları',
        base: 'payment-reports',
        icon: 'report-money',
        role: [PermissionType.SUPER_ADMIN_MANAGE_PAYMENTS],
      },
      {
        link: routes.parasutInvoices,
        label: 'Faturalar',
        base: 'parasut-invoices',
        icon: 'file-invoice',
        role: [PermissionType.SUPER_ADMIN_VIEW_INVOICES],
      },
    ]
  },
  // === ÜRÜN YÖNETİMİ ===
  {
    tittle: 'sidebar_menu.main_menu.productsTitle',
    icon: 'package',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_MANAGE_PRODUCTS],
    submenuItems: [
      {
        link: routes.productManagement,
        label: 'Ürün Yönetimi',
        base: 'product-management',
        icon: 'package',
        role: [PermissionType.SUPER_ADMIN_MANAGE_PRODUCTS],
      }
    ]
  },
  // === İLETİŞİM YÖNETİMİ ===
  {
    tittle: 'Bildirim Yönetimi',
    icon: 'bell',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_BROADCAST],
    submenuItems: [
      {
        link: routes.superAdminBroadcast,
        label: 'Toplu Bildirim Gönder',
        base: 'broadcast',
        icon: 'send',
        role: [PermissionType.SUPER_ADMIN_BROADCAST],
      }
    ]
  },

  // === SİSTEM YÖNETİMİ ===
  {
    tittle: 'Sistem Yönetimi',
    icon: 'settings',
    showAsTab: false,
    separateRoute: false,
    role: [PermissionType.SUPER_ADMIN_USER_MANAGEMENT, PermissionType.SUPER_ADMIN_SYSTEM_SETTINGS],
    submenuItems: [
      {
        link: routes.superAdminUsers,
        label: 'Kullanıcı Yönetimi',
        base: 'users',
        icon: 'users',
        role: [PermissionType.SUPER_ADMIN_USER_MANAGEMENT],
      },
      {
        link: routes.superAdminDeviceConflicts,
        label: 'Cihaz ID Sıfırlama',
        base: 'device-conflicts',
        icon: 'device-mobile-exclamation',
        role: [PermissionType.SUPER_ADMIN_USER_MANAGEMENT],
      }
    ]
  },
];